<canvas
  baseChart
  height="500"
  [type]="chartType()"
  [data]="chartData"
  [options]="chartOptions"
  [legend]="chartLegend"
>
</canvas>
